export type AgentOffice = 'front' | 'back';
export type AgentChatStatus = 'online' | 'away';
export type AgentDerivedStatus = 'online' | 'away' | 'full' | 'offline';

export type AgentRosterEntry = {
  userId: string;
  fullName: string | null;
  email: string | null;
  alias: string;
  office: AgentOffice;
  maxChats: number;
  chatStatus: AgentChatStatus;
  derivedStatus: AgentDerivedStatus;
  load: { active: number; max: number };
  lastSeenAt: string | null;
};

export type AgentUserRow = {
  userId: string;
  fullName: string | null;
  email: string | null;
  role: string | null;
  isChatAgent: boolean;
  alias: string | null;
};

export type AgentLiveChat = {
  id: string;
  customerName: string | null;
  lastMessage: string | null;
  updatedAt: string | null;
};

export type AgentResolvedChat = {
  id: string;
  customerName: string | null;
  resolvedAt: string | null;
};

export type AgentDetail = AgentRosterEntry & {
  stats: { resolvedToday: number; resolvedWeek: number; avgResponseMins: number | null };
  liveChats: AgentLiveChat[];
  recentResolved: AgentResolvedChat[];
};

export type CreateAgentInput = {
  userId: string;
  alias: string;
  office?: AgentOffice;
  maxChats?: number;
  fullName?: string | null;
};

export type UpdateAgentInput = {
  alias?: string;
  office?: AgentOffice;
  maxChats?: number;
  chatStatus?: AgentChatStatus;
  active?: boolean;
  fullName?: string | null;
};

export function agentRealName(entry: { fullName: string | null; email: string | null }): string {
  return entry.fullName?.trim() || entry.email || 'Okänd användare';
}
